import * as actions from "../actions/actions";
import { connect } from "react-redux";
import { hashHistory } from "react-router";
import React from "react";

import Icon from "./nounproject-ui-icon";
import PluginToolbar from "./plugin-toolbar";
import PluginFooter from "./plugin-footer";

class PluginFacebook extends React.Component {
    closeFacebook(e) {
        e.preventDefault();
        hashHistory.push("search");
    }

    render() {
        return (
            <span>
                <div className="quick-nav">
                    <PluginToolbar />
                </div>
                <div
                    className="plugin-about"
                    style={{
                        background: "black",
                        color: "white",
                        padding: "50px 16px 100px",
                        minHeight: "100%"
                    }}
                >
                    <div className="plugin-menu-header">
                        <a
                            href="#"
                            className="menu-close"
                            onClick={this.closeFacebook.bind(this)}
                            title="Cancel"
                        >
                            <Icon
                                iconId="close.svg"
                                className="icon-14"
                                color="#FFFFFF"
                            />
                        </a>
                    </div>
                    <div
                        style={{
                            maxWidth: "600px",
                            margin: "auto"
                        }}
                    >
                        <h1 className="font-large margin-b-s">
                            A password is required to log in
                        </h1>
                        <p>
                            If you don't have a password because you use
                            Facebook to log in, or you don't remember it, create
                            a new password from your{" "}
                            <a
                                href="/accounts/password/set/"
                                target="_blank"
                                onClick={window.handleLink.bind(this)}
                                style={{
                                    color: "#FFFFFF",
                                    textDecoration: "underline"
                                }}
                            >
                                account settings
                            </a>{" "}
                            page.
                        </p>

                        <div className="margin-t-xxl">
                            <a
                                className="button ui_key full-width blue"
                                href="/accounts/password/set/"
                                target="_blank"
                                onClick={window.handleLink.bind(this)}
                                style={{
                                    color: "#FFFFFF",
                                    textDecoration: "underline"
                                }}
                            >
                                <span>Create new password</span>
                            </a>
                        </div>

                        <div
                            className="weight-medium"
                            style={{ textAlign: "center" }}
                        >
                            <a
                                href="#"
                                onClick={this.showLogin.bind(this)}
                                style={{
                                    color: "#FFFFFF",
                                    textDecoration: "underline"
                                }}
                            >
                                I remember my password, log me in
                            </a>
                        </div>
                    </div>
                </div>

                <PluginFooter />
            </span>
        );
    }

    showLogin(e) {
        e.preventDefault();
        hashHistory.push("login");
    }
}

function mapStateToProps(state, ownProps) {
    let host = state.plugin.host;

    return { host };
}

module.exports = connect(mapStateToProps, {})(PluginFacebook);
